<div>
  <form [formGroup]="generalAccountInfoForm" *ngIf="formLoaded">
    <ion-item>
      <ion-select [label]="'GENERAL.ACCOUNT_TYPE' | translate" formControlName="type" [disabled]="!canAdminister">
        <ion-select-option value="Company">{{ 'GENERAL.COMPANY' | translate }}</ion-select-option>
        <ion-select-option value="Personal">{{ 'GENERAL.PERSONAL' | translate }}</ion-select-option>
        <ion-select-option value="School">{{ 'GENERAL.SCHOOL' | translate }}</ion-select-option>
        <ion-select-option value="College / University">{{ 'GENERAL.COLLEGE_UNIVERSITY' | translate }}</ion-select-option>
        <ion-select-option value="School District">{{ 'GENERAL.SCHOOL_DISTRICT' | translate }}</ion-select-option>
        <ion-select-option value="Free" *ngIf="type === 'Free'">{{ 'GENERAL.FREE' | translate }}</ion-select-option>
        <ion-select-option value="Trial" *ngIf="type === 'Trial'" [disabled]="true">{{ 'GENERAL.TRIAL' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="type === 'Free' && canAdminister && isToggleEnabled('freeToPremium')">
      <ion-label>{{ 'GENERAL.UPGRADE_TO_TRIAL' | translate }}</ion-label>
      <ion-button 
        slot="end" 
        color="primary" 
        (click)="upgradeToTrial()"
        [disabled]="updatePending">
        {{ 'GENERAL.UPGRADE' | translate }}
      </ion-button>
    </ion-item>
    
    <!-- <ion-item >
      <ion-input [label]="'GENERAL.NUMBER_OF_KILNS' | translate" class="ion-text-right" [readonly]="!editing" formControlName="numberControllers"></ion-input>
    </ion-item> -->

    <ion-item>
      <ion-input disabled="true" type="date" format="MMM dd, yyyy" [label]="'GENERAL.EXPIRATION' | translate" *ngIf="expiration" [class.danger]="isExpired" [value]="expiration"></ion-input>
      <ion-input disabled="true" [label]="'GENERAL.EXPIRATION' | translate" *ngIf="!expiration">{{ 'GENERAL.NOT_AVAILABLE' | translate }}</ion-input>
    </ion-item>

    <ion-item>
      <ion-select [label]="'GENERAL.TIME_ZONE' | translate" formControlName="timezone" [class.invalid]="generalAccountInfoForm && generalAccountInfoForm.controls.timezone.valid && generalAccountInfoForm.controls.timezone.touched" [disabled]="!canAdminister">
        <ion-select-option class="default-us-timezone" *ngFor="let zone of getTopUSTimezones()" [value]="zone">{{zone}}</ion-select-option>
        <ion-select-option *ngFor="let zone of getTimezones()" [value]="zone">{{zone}}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="canAdminister && isToggleEnabled('accountDistributor')">
      <ion-select
        [label]="'GENERAL.DISTRIBUTOR' | translate"
        formControlName="distributor_id"
        [disabled]="distributorLoading"
        [placeholder]="'GENERAL.DISTRIBUTOR_NONE' | translate"
      >
        <ion-select-option [value]="''">{{ 'GENERAL.DISTRIBUTOR_NONE' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let d of distributorOptions" [value]="d.id">{{ distributorLabel(d) }}</ion-select-option>
      </ion-select>
      <ion-button
        slot="end"
        size="small"
        fill="solid"
        color="primary"
        (click)="saveDistributorOnly()"
        [disabled]="distributorLoading || distributorSavePending"
      >
        {{ 'GENERAL.DISTRIBUTOR_SAVE' | translate }}
      </ion-button>
    </ion-item>
    
      <!-- Language selector as a form field -->
    <ion-item class="language-item" button (click)="openLanguageSwitcher()" *ngIf="isToggleEnabled('internationalization')">
      <ion-label class="ion-text-wrap">
        <div>{{ 'ACCOUNT_SETTINGS.LANGUAGE' | translate }}</div>
        <ion-note color="medium" class="language-user-only-note">{{ 'GENERAL.LANGUAGE_APPLIES_TO_YOU_ONLY' | translate }}</ion-note>
      </ion-label>
      <div slot="end" class="language-display">
        <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
        <span class="language-name">{{ currentLanguageInfo.name }}</span>
        <ion-icon name="chevron-forward" color="medium"></ion-icon>
      </div>
    </ion-item>

    <ion-item *ngIf="isToggleEnabled('freeToPremium') && type === 'Free'">
      <ion-label>{{ 'GENERAL.START_SUBSCRIPTION' | translate }}</ion-label>
      <ion-button slot="end" color="primary" (click)="startSubscription()">
        {{ 'GENERAL.START_SUBSCRIPTION' | translate }}
      </ion-button>
    </ion-item>
    <ion-item *ngIf="shouldShowCostPerYearAndPayment()" class="cost-per-year-item">
      <ion-label>{{ 'GENERAL.COST_PER_YEAR' | translate }} $19.99/year</ion-label>
    </ion-item>
    <ion-item *ngIf="shouldShowCostPerYearAndPayment()">
      <app-account-payment #paymentsForm (startEdit)="startEditing(true)" slot="end"
        [accountInformation]="accountInformation" [canAdminister]="canAdminister" [editing]="!!canAdminister">
      </app-account-payment>
    </ion-item>
  </form>  

  <ion-row class="general-actions ion-justify-content-end ion-padding-end">
    <ion-button size="small" *ngIf="canAdminister" color="light" (click)="delete()">{{ 'GENERAL.DELETE' | translate }}</ion-button>
    <ion-button size="small" *ngIf="canAdminister" color="secondary" (click)="cancelEditing()">{{ 'GENERAL.CANCEL' | translate }}</ion-button>
    <ion-button size="small" type="submit"
      [disabled]="!isValid() || !canAdminister"
      (click)="save()" *ngIf="!updatePending">{{ 'GENERAL.SUBMIT' | translate }}</ion-button>
    <div *ngIf="updatePending" class="submitpending">
      <ion-spinner name='bubbles'></ion-spinner>
      <span>{{ 'GENERAL.UPDATING' | translate }}</span>
    </div>
  </ion-row>

  <ion-row class="ion-justify-content-end ion-padding-end premium-row" *ngIf="isToggleEnabled('freeToPremium') && trialAvailable() && !accountExpired() && type === 'Free'">
    <div class="premium-upgrade">
      <div class="premium-content">
        <ion-icon name="star-outline" class="premium-icon"></ion-icon>
        <div class="premium-text">
          <p class="premium-title">{{ 'USER_INFO.PREMIUM_FEATURES_AVAILABLE' | translate }}</p>
        </div>
      </div>
      <ion-button (click)="upgradeToTrial()" fill="solid" color="primary" class="premium-button">
        <ion-icon name="rocket-outline" slot="start"></ion-icon>
        {{ 'USER_INFO.START_TRIAL' | translate }}
      </ion-button>
    </div>
  </ion-row>

</div>
